module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hotsite', {
    attrs: {
      "nome": "Diretoria de Compras - DCOM",
      "tema": "theme-blue",
      "capa": "../../../static/banner_hotsite.jpg",
      "menu": _vm.aside_links,
      "links": _vm.footer_links,
      "breadcrumb": _vm.breadcrumb
    }
  }, [_c('template', {
    slot: "conteudo"
  }, [_vm._t("default")], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cba5e672","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/pages/dcom/Base.vue
// module id = 516
// module chunks = 0